import { render } from "./Orders.vue?vue&type=template&id=03e47970"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"

import "./Orders.vue?vue&type=style&index=0&id=03e47970&lang=css"
script.render = render

export default script